<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'" class="component-wrapper">
    <app-sokusai-management-login class="component"></app-sokusai-management-login>
  </div>

  <div *ngIf="page === 'register'" class="component-wrapper">
    <app-sokusai-management-register class="component"></app-sokusai-management-register>
  </div>

  <div *ngIf="page === 'forgot-password'" class="component-wrapper">
    <app-sokusai-management-forgot-password class="component"></app-sokusai-management-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'" class="component-wrapper">
    <app-sokusai-management-change-password-sent class="component"></app-sokusai-management-change-password-sent>
  </div>

  <div class="component-wrapper">
    <app-sokusai-management-register-resend
      *ngIf="page === 'register-resend'"
    ></app-sokusai-management-register-resend>
  </div>
</ng-container>
